import { generatedByKey, generatedPages, generatedTourById } from './generatedPages';

const SITE = 'https://classiquemobility.com';

/** Normalize generated keys to stable route keys */
const KEY_ALIASES = {
  becometourvendor: 'become-tour-vendor',
  'airport-transfers-jacksonville': 'airport-transfers-in-jacksonville-florida',
  'jacksonville-florida-tours': 'tours-in-jacksonville-florida',
};

/** Manual fallbacks when the extract parser missed a page */
const FALLBACK_PAGES = {
  'about-us': {
    key: 'about-us',
    canonicalPath: '/about-us',
    title: 'About Us | Classique Mobility',
    description:
      'Learn about Classique Mobility, providing Jamaica Transportation, Jamaica Airport Transfers and Jamaica Tours with reliable travel services across the island.',
    h1: 'About Us',
    ctaMode: 'transfers',
    sections: [
      {
        h2: 'About Classique Mobility',
        paragraphs: [
          'Classique Mobility is built around a simple idea: getting around Jamaica should be comfortable, reliable, and easy to arrange. We provide Jamaica Transportation services designed for travelers who want a smooth experience from the moment they arrive until the end of their journey. From airport pickups and private transfers to tours and local travel experiences, Classique Mobility helps travelers move around Jamaica with confidence.',
          'Whether you are visiting Jamaica for a vacation, business trip, family holiday, or special occasion, our goal is to make transportation one less thing to worry about.',
        ],
      },
      {
        h2: 'Reliable Jamaica Transportation Services',
        paragraphs: [
          'Jamaica Transportation is an important part of every successful island experience. Travelers need dependable ways to move between airports, hotels, resorts, attractions, cities, and destinations across the country.',
          'Classique Mobility provides convenient transportation solutions for different types of travelers and travel requirements. Our services are designed around comfort, convenience, professional service, and an easy booking experience.',
          'From Montego Bay and surrounding destinations to other popular areas across Jamaica, we help travelers plan their transportation before and during their trip.',
        ],
      },
      {
        h2: 'Jamaica Airport Transfers Made Simple',
        paragraphs: [
          'Arriving at a new destination should be exciting, not stressful. Our Jamaica Airport Transfers are designed to make the journey from the airport to your hotel, resort, villa, or other destination more convenient.',
          'With Classique Mobility, travelers can arrange Jamaica Airport Transfers as part of their overall travel plans and enjoy a smoother transition from arrival to vacation.',
          'Our transportation services can support travelers arriving through major Jamaican airports and heading to popular destinations across the island. Whether you are traveling alone, with family, as a couple, or as part of a group, we aim to provide a comfortable and dependable travel experience.',
        ],
      },
      {
        h2: 'Discover Jamaica With Private Tours',
        paragraphs: [
          'Jamaica is more than beaches and resorts. The island offers beautiful landscapes, cultural experiences, local attractions, food, adventure, and unforgettable destinations.',
          'Our Jamaica Tours help travelers discover more of what the island has to offer. Whether you want to explore popular attractions or experience a different side of Jamaica, Classique Mobility connects transportation with memorable travel experiences.',
          'Private Jamaica Tours can also provide greater flexibility for travelers who want to explore the island according to their own interests and schedule.',
        ],
      },
      {
        h2: 'Travel Across Jamaica With Confidence',
        paragraphs: [
          'At Classique Mobility, we believe Jamaica Transportation should be more than simply getting from one location to another. It should be part of a positive travel experience.',
          'That means focusing on convenient service, comfortable transportation, clear communication, and support throughout the journey. Our Jamaica Travel Services are designed to help visitors spend less time worrying about logistics and more time enjoying Jamaica.',
        ],
      },
      {
        h2: 'Our Commitment to Quality & Service',
        paragraphs: [
          'Every traveler has different needs, which is why we focus on providing flexible transportation and travel solutions. Whether you need Jamaica Airport Transfers, private transportation, or Jamaica Tours, our goal is to make your journey straightforward from booking to arrival and beyond.',
          'We continue to build our services around travelers, partners, and destinations while developing a broader mobility network across Jamaica and the Caribbean.',
        ],
      },
      {
        h2: 'Start Your Jamaica Journey With Classique Mobility',
        paragraphs: [
          'From your airport arrival to exploring the island, Classique Mobility is here to help make your journey easier. Choose reliable Jamaica Transportation, arrange Jamaica Airport Transfers, and discover memorable Jamaica Tours designed around your travel plans.',
          'Your Jamaica journey starts with Classique Mobility.',
        ],
      },
    ],
    imageAlts: [],
  },
  'popular-destinations': {
    key: 'popular-destinations',
    canonicalPath: '/popular-destinations',
    title: 'Popular Destinations | Travel Destinations | Classique',
    description:
      'Explore popular travel destinations with Classique Mobility. Browse experiences, airport transfers, tours and car rentals across our global locations.',
    h1: 'Explore Popular Destinations',
    ctaMode: 'tours',
    sections: [
      {
        h2: 'Discover Destinations Around the World',
        paragraphs: [
          'Classique Mobility helps travelers explore popular destinations across North America, the Caribbean and beyond. Browse destination hubs to find tours, airport transfers and transportation options designed for your trip.',
          'Select a destination below to view curated experiences, or continue to our destination-specific pages for transfers, tours and car rentals.',
        ],
      },
      {
        h2: 'Plan Your Journey With Classique Mobility',
        paragraphs: [
          'Whether you need a rental vehicle, private airport transportation or guided tours, Classique Mobility brings travel services together so you can plan with confidence.',
        ],
      },
    ],
    imageAlts: [],
  },
  'car-rentals-in-jamaica': {
    key: 'car-rentals-in-jamaica',
    canonicalPath: '/car-rentals-in-jamaica',
    title: 'Car Rentals in Jamaica | Jamaica Car Rental | Classique',
    description:
      'Book Car Rentals in Jamaica with Classique Mobility. Enjoy flexible Jamaica car rental options for exploring Montego Bay, Kingston, Negril, Ocho Rios and beyond.',
    h1: 'Car Rentals in Jamaica – Jamaica Car Rental Services',
    ctaMode: 'cars',
    sections: [
      {
        h2: 'Explore Jamaica With a Rental Car',
        paragraphs: [
          'Classique Mobility provides Car Rentals in Jamaica for travelers who want the freedom to explore the island on their own schedule. Whether you are visiting for vacation, business or an extended stay, a Jamaica Car Rental can make it easier to travel between airports, hotels, resorts, beaches and attractions.',
          'From Montego Bay and Kingston to Negril, Ocho Rios and other popular destinations, arrange a rental vehicle that fits your itinerary and group size.',
        ],
      },
      {
        h2: 'Book Your Jamaica Car Rental',
        paragraphs: [
          'Ready to explore Jamaica independently? Choose Car Rentals in Jamaica with Classique Mobility and start planning your trip with convenient pickup options and clear booking support.',
        ],
      },
    ],
    imageAlts: [],
  },
  'tours-in-barbados': {
    key: 'tours-in-barbados',
    canonicalPath: '/tours-in-barbados',
    title: 'Barbados Tours & Excursions | Private Tours in Barbados',
    description:
      'Discover Barbados Tours and private excursions with Classique Mobility. Explore beaches, history, culture, nature and island experiences across Barbados.',
    h1: 'Barbados Tours & Excursions – Explore Barbados Your Way',
    ctaMode: 'tours',
    sections: [
      {
        h2: 'Explore Barbados Tours & Excursions',
        paragraphs: [
          'Classique Mobility provides Barbados Tours and private travel experiences designed to help visitors explore the island comfortably and conveniently.',
          'Whether you are visiting for a family vacation, romantic getaway, cruise stop, business trip or extended holiday, choose a tour experience that matches your interests, schedule and travel plans.',
        ],
      },
      {
        h2: 'Private Tours in Barbados',
        paragraphs: [
          'A Private Tour in Barbados gives travelers greater flexibility when planning their experience. Private transportation can be particularly useful for families, couples, corporate travelers and groups who prefer a more personalized itinerary.',
        ],
      },
    ],
    imageAlts: [],
  },
};

function withAlias(map) {
  const out = { ...map, ...FALLBACK_PAGES };
  Object.entries(KEY_ALIASES).forEach(([from, to]) => {
    if (out[from] && !out[to]) {
      out[to] = {
        ...out[from],
        key: to,
        canonicalPath: `/${to}`,
      };
    }
  });
  // Prefer general popular-destinations hub SEO (not Jamaica-only)
  if (FALLBACK_PAGES['popular-destinations']) {
    out['popular-destinations'] = FALLBACK_PAGES['popular-destinations'];
    out['jamaica-destinations'] = FALLBACK_PAGES['popular-destinations'];
  }
  if (FALLBACK_PAGES['about-us']) {
    out['about-us'] = FALLBACK_PAGES['about-us'];
  }
  if (out['become-tour-vendor']) {
    out['become-tour-vendor'] = {
      ...out['become-tour-vendor'],
      canonicalPath: '/BecomeTourVendor',
    };
  }
  if (FALLBACK_PAGES['tours-in-barbados']) {
    out['tours-in-barbados'] = FALLBACK_PAGES['tours-in-barbados'];
  }
  return out;
}

export const seoByKey = withAlias(generatedByKey);
export const seoTourById = generatedTourById;
export const allSeoPages = generatedPages;

export function getSeoPage(key) {
  return seoByKey[key] || null;
}

export function getSeoTour(id) {
  if (id == null) return null;
  return seoTourById[String(id)] || null;
}

export function resolveCtas(page) {
  if (!page) return [];
  const mode = page.ctaMode || 'tours';
  if (mode === 'cars') {
    return [
      { label: 'Search Car Rentals', to: '/car-listing' },
      { label: 'View Locations', to: '/locations', variant: 'secondary' },
    ];
  }
  if (mode === 'transfers' || mode === 'tours') {
    return [
      { label: 'Browse Experiences', to: '/destination-listing' },
      { label: 'Popular Destinations', to: '/popular-destinations', variant: 'secondary' },
    ];
  }
  if (mode === 'franchise' || mode === 'vendor') {
    return [{ label: 'Contact Us', to: '/ContactUs' }];
  }
  return [{ label: 'Explore', to: '/' }];
}

export const SEO_LANDING_ROUTES = [
  { path: '/airport-transfers-in-jamaica', key: 'airport-transfers-in-jamaica', bg: 'bg-contact-img' },
  { path: '/tours-in-jamaica', key: 'tours-in-jamaica', bg: 'bg-contact-img' },
  { path: '/car-rentals-in-jamaica', key: 'car-rentals-in-jamaica', bg: 'bg-contact-img' },
  { path: '/car-rentals-in-trinidad', key: 'car-rentals-in-trinidad', bg: 'bg-contact-img' },
  { path: '/airport-transfers-in-trinidad', key: 'airport-transfers-in-trinidad', bg: 'bg-contact-img' },
  { path: '/tours-in-trinidad', key: 'tours-in-trinidad', bg: 'bg-contact-img' },
  { path: '/car-rentals-in-tobago', key: 'car-rentals-in-tobago', bg: 'bg-contact-img' },
  { path: '/airport-transfers-in-tobago', key: 'airport-transfers-in-tobago', bg: 'bg-contact-img' },
  { path: '/tours-in-tobago', key: 'tours-in-tobago', bg: 'bg-contact-img' },
  { path: '/car-rentals-in-puerto-rico', key: 'car-rentals-in-puerto-rico', bg: 'bg-contact-img' },
  { path: '/airport-transfers-in-puerto-rico', key: 'airport-transfers-in-puerto-rico', bg: 'bg-contact-img' },
  { path: '/tours-in-puerto-rico', key: 'tours-in-puerto-rico', bg: 'bg-contact-img' },
  { path: '/car-rentals-in-jacksonville-florida', key: 'car-rentals-in-jacksonville-florida', bg: 'bg-contact-img' },
  { path: '/airport-transfers-in-jacksonville-florida', key: 'airport-transfers-in-jacksonville-florida', bg: 'bg-contact-img' },
  { path: '/tours-in-jacksonville-florida', key: 'tours-in-jacksonville-florida', bg: 'bg-contact-img' },
  { path: '/car-rentals-in-barbados', key: 'car-rentals-in-barbados', bg: 'bg-contact-img' },
  { path: '/airport-transfers-in-barbados', key: 'airport-transfers-in-barbados', bg: 'bg-contact-img' },
  { path: '/tours-in-barbados', key: 'tours-in-barbados', bg: 'bg-contact-img' },
  { path: '/car-rentals-in-nassau-bahamas', key: 'car-rentals-in-nassau-bahamas', bg: 'bg-contact-img' },
  { path: '/airport-transfers-in-nassau-bahamas', key: 'airport-transfers-in-nassau-bahamas', bg: 'bg-contact-img' },
  { path: '/tours-in-bahamas', key: 'tours-in-bahamas', bg: 'bg-contact-img' },
];

export function relatedLandingsFor(path) {
  const countryHints = [
    { test: /jamaica/, links: [
      { label: 'Airport Transfers in Jamaica', to: '/airport-transfers-in-jamaica' },
      { label: 'Tours in Jamaica', to: '/tours-in-jamaica' },
      { label: 'Car Rentals in Jamaica', to: '/car-rentals-in-jamaica' },
      { label: 'Popular Destinations', to: '/popular-destinations' },
    ]},
    { test: /trinidad/, links: [
      { label: 'Car Rentals in Trinidad', to: '/car-rentals-in-trinidad' },
      { label: 'Airport Transfers in Trinidad', to: '/airport-transfers-in-trinidad' },
      { label: 'Tours in Trinidad', to: '/tours-in-trinidad' },
    ]},
    { test: /tobago/, links: [
      { label: 'Car Rentals in Tobago', to: '/car-rentals-in-tobago' },
      { label: 'Airport Transfers in Tobago', to: '/airport-transfers-in-tobago' },
      { label: 'Tours in Tobago', to: '/tours-in-tobago' },
    ]},
    { test: /puerto-rico/, links: [
      { label: 'Car Rentals in Puerto Rico', to: '/car-rentals-in-puerto-rico' },
      { label: 'Airport Transfers in Puerto Rico', to: '/airport-transfers-in-puerto-rico' },
      { label: 'Tours in Puerto Rico', to: '/tours-in-puerto-rico' },
    ]},
    { test: /jacksonville/, links: [
      { label: 'Car Rentals in Jacksonville', to: '/car-rentals-in-jacksonville-florida' },
      { label: 'Airport Transfers in Jacksonville', to: '/airport-transfers-in-jacksonville-florida' },
      { label: 'Tours in Jacksonville', to: '/tours-in-jacksonville-florida' },
    ]},
    { test: /barbados/, links: [
      { label: 'Car Rentals in Barbados', to: '/car-rentals-in-barbados' },
      { label: 'Airport Transfers in Barbados', to: '/airport-transfers-in-barbados' },
      { label: 'Tours in Barbados', to: '/tours-in-barbados' },
    ]},
    { test: /bahamas|nassau/, links: [
      { label: 'Car Rentals in Nassau Bahamas', to: '/car-rentals-in-nassau-bahamas' },
      { label: 'Airport Transfers in Nassau Bahamas', to: '/airport-transfers-in-nassau-bahamas' },
      { label: 'Tours in Bahamas', to: '/tours-in-bahamas' },
    ]},
  ];
  const hit = countryHints.find((c) => c.test.test(path));
  return (hit?.links || []).filter((l) => l.to !== path);
}

export { SITE };
